import React from 'react';

import {
  Icon,
  Tooltip,
} from 'web-components';

import * as S from '../styled';

const InlineStyle = ({
  editorState,
  onToggle,
}) => {
  const INLINE_STYLES = [
    {
      icon: 'fa fa-bold',
      style: 'BOLD',
      tooltip: 'Bold (Ctrl+B)',
    },
    {
      icon: 'fa fa-italic',
      style: 'ITALIC',
      tooltip: 'Italic (Ctrl+I)',
    },
    // {
    //   icon: 'fa fa-underline',
    //   style: 'UNDERLINE',
    //   tooltip: 'Underline (Ctrl+U)',
    // },
  ];

  const currentStyle = editorState.getCurrentInlineStyle();
  return INLINE_STYLES.map(type => (
    <Tooltip
      key={type.style}
      body={type.tooltip}
      preferPlace="above"
    >
      <S.Control
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onToggle(type.style);
        }}
        isActive={currentStyle.has(type.style)}
      >
        <Icon type={type.icon} />
      </S.Control>
    </Tooltip>
  ));
};

export default InlineStyle;
